import React, { useState, useEffect, useRef } from 'react'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import clsx from 'clsx'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import Timer from '../../components/molecules/Timer'
import {
    currencyFormat,
    handleRedirectInternal,
    useCustomMediaQuery,
} from '../../common/components'
import Chat from '../../components/organisms/Chat'
import './ProductView.css'
import axios from '../../Utils/Utility/axiosconfig'
import { useParams, useHistory, Link, useLocation } from 'react-router-dom'
import { socket, reInitializeSocket, socketSeller } from '../../common/socket'
import moment from 'moment-timezone'
import publicIp from 'public-ip'
// import ipLocation from 'iplocation'
import {
    onImageError,
    onImageErrorScroll,
    setDecimalPoint,
    getPaginationCount,
    getnearteImages,
} from '../../Utils/Utility'
import ProductViewSlider from '../../components/organisms/ProdutViewSlider'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import isAuthenticate from '../../Utils/Utility/auth'
import { connect, useDispatch, useSelector } from 'react-redux'
import updateFav from '../../Utils/API/fav'
import { findIndex } from 'lodash'
import Pagination from '@material-ui/lab/Pagination'
import qs from 'qs'
import preAuctionBid from '../../Utils/API/preAuctionBid'
import commonBidding from '../../Utils/API/nomalBidding'
import BidHistory from '../../components/organisms/BidHistory'
import { Button, Chip, Drawer, IconButton } from '@material-ui/core'
import Gridview from '../../components/molecules/ProductCard/GridView'
import Swal from 'sweetalert2'
import bidding from '../../Utils/API/bidding'
import Loaders from '../../components/molecules/Loader'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import MobileListCard from '../../components/molecules/MobileListCard'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import rapidSearch from '../../actions/rapidSearch'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import Popup from '../../components/organisms/Popup'
import CheckBox from '../../components/atoms/CheckBox/index'
import { messageHandler } from '../../common/sockethandler'

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
    },
}))

function ProductView(props) {
    const [lotData, setLotData] = useState({})
    const [auctionData, setAuctionData] = useState([])
    const [isOpen, setOpen] = useState(false)
    const [data, setData] = useState({})
    const [body, setBody] = useState({})
    const [newBody, setnewBody] = useState({})
    const [anchorEl, setAnchorEl] = useState(null)
    const [popText, setPopText] = useState('')
    const [amount, setAmount] = useState({})
    const [auctionView, setAuctionView] = useState('Grid')
    const [historyId, setHistoryId] = useState(undefined)
    const open = Boolean(anchorEl)
    const { id } = useParams()
    const history = useHistory()
    const classes = useStyles()
    const [showTimer, setTimer] = useState(true)
    const [ipaddresss, setIPAddress] = useState('')
    const [tDrawer, setTDrawer] = useState(false)
    const [loading, setLoading] = useState(true)
    const [pageLotCount, setPageLotCount] = useState(20)
    const mobile = useMediaQuery('(max-width:700px)')
    const [bidUpdate, setbidUpdate] = useState('')
    const [showDescription, setShowDescription] = useState(false)
    const [closedData, setClosedData] = useState('')
    const [bidPriceData, setBidPriceData] = useState({})
    const [bidCancelData, setBidCancelData] = useState({})
    const [auctionClosedData, setAuctionClosedData] = useState({})
    const [isRegisterLiveAuctionEnabled, setIsRegisterLiveAuctionEnabled] = useState(false)
    const [scrollHeight, setScrollHeigth] = useState(0)
    const [lotText, setLotText] = useState('')
    const location = useLocation()
    const dispatch = useDispatch()
    const [searchText, setSearchText] = React.useState([])
    const [modalOpen, setmodalOpen] = useState(false)
    const [agreeterms, setAgreeterms] = useState(false)
    const terms_condition = useSelector((state) => state.storeDetails)
    const [user, setUser] = useState()
    const [sticky, setSticky] = useState({ isSticky: false, offset: 0 })
    const headerRef = useRef(null)
    let queryVw = qs.parse(props.location.search, { ignoreQueryPrefix: true })

    const handleScroll = (elTopOffset, elHeight) => {
        if (window.pageYOffset > elTopOffset + elHeight) {
            setSticky({ isSticky: true, offset: elHeight })
        } else {
            setSticky({ isSticky: false, offset: 0 })
        }
    }

    useEffect(() => {
        var header = headerRef?.current?.getBoundingClientRect?.()
        const handleScrollEvent = () => {
            handleScroll(header.top, header.height)
        }
        window.addEventListener('scroll', handleScrollEvent)

        return () => {
            window.removeEventListener('scroll', handleScrollEvent)
        }
    }, [handleScroll])

    useEffect(() => {
        setUser(props.userDetails.userdetails)
    }, [props.userDetails.userdetails])

    useEffect(() => {
        if (queryVw.perPage) {
            setPageLotCount(Number(queryVw.perPage))
            console.log(
                getPaginationCount(lotData?.lot_count, pageLotCount),
                Number(body.page),
                getPaginationCount(lotData?.lot_count, pageLotCount) < Number(body.page),
                'page count',
            )
            if (getPaginationCount(lotData?.lot_count, pageLotCount) < body.page) {
                let query = new URLSearchParams(props.location.search)
                query.set('page', 1)
                history.push({
                    pathname: props.location.pathname,
                    search: '?' + query.toString(),
                })
            }
        }
    }, [queryVw?.perPage])

    useEffect(() => {
        if (queryVw.lotSearch != '') {
            setLotText(queryVw.lotSearch)
        }
    }, [queryVw?.lotSearch])

    useEffect(() => {
        console.log(props.location.search, 'props.location.search')
        if (isAuthenticate() && !props.userDetails.userdetails.id) {
        } else {
            if (props.location.search != '') {
                console.log(
                    'if condition block executed',
                    pageLotCount,
                    !props.userDetails.userdetails.id && isAuthenticate(),
                )
                let query = qs.parse(props.location.search, { ignoreQueryPrefix: true })
                console.log('props.location.search query', query)
                if (query.perPage) {
                    if (pageLotCount == query.perPage) {
                        setTimeout(() => {
                            setBody({
                                auction_io: 1,
                                limit: pageLotCount,
                                sortBy: 1,
                                page: query.page || 1,
                                lotof: id,
                                order: 1,
                                userid: props.userDetails.userdetails.id
                                    ? props.userDetails.userdetails.id
                                    : '',
                                searchbar_with_lot_number: query.lotSearch ? query.lotSearch : '',
                            })
                        }, 1000)
                    }
                } else {
                    setTimeout(() => {
                        setBody({
                            auction_io: 1,
                            limit: pageLotCount,
                            sortBy: 1,
                            page: query.page || 1,
                            lotof: id,
                            order: 1,
                            userid: props.userDetails.userdetails.id
                                ? props.userDetails.userdetails.id
                                : '',
                            searchbar_with_lot_number: query.lotSearch ? query.lotSearch : '',
                        })
                    }, 1000)
                }

                if (query.scrollLocation) {
                    setScrollHeigth(query.scrollLocation)
                }
            } else {
                setBody({
                    auction_io: 1,
                    limit: pageLotCount,
                    sortBy: 1,
                    page: 1,
                    lotof: id,
                    order: 1,
                    userid: props.userDetails.userdetails.id
                        ? props.userDetails.userdetails.id
                        : '',
                    searchbar_with_lot_number: queryVw.lotSearch ? queryVw.lotSearch : '',
                })
                history.push({ pathname: `${props.location.pathname}?page=1` })
            }
        }
    }, [props.location.search, props.userDetails.userdetails.id, pageLotCount])

    useEffect(() => {
        if (Object.keys(body).length !== 0) {
            getLotAuctions(body)
            setLoading(true)
            setnewBody(body)
        }
        console.log('body changed', body)
    }, [body])

    const handleHistory = (val) => setHistoryId(val)

    // const getLotData = async () => {
    //     let { data } = await axios.post('mobileapi/getauctionlotdetails', { auctionid: id })
    //     if (data && data.success === true) {
    //         data.data.auction_details.is_registered = data.data.is_registered
    //         console.log(
    //             'innnnnnnnnnnnnnnnnnnnnnnnn',
    //             new Date(),
    //             new Date(data.data.auction_details.date_added),
    //         )
    //         if (new Date(data.data.auction_details.date_added) >= new Date()) {
    //             data.data.auction_details.preview_date_reached = 1
    //         } else {
    //             data.data.auction_details.preview_date_reached = 0
    //         }
    //         if (data.data.is_registered_list.length > 0) {
    //             if (data.data.is_registered_list[0].status == 'active') {
    //                 data.data.auction_details.is_register_active = 0
    //             } else {
    //                 data.data.auction_details.is_register_active = 1
    //             }
    //         } else {
    //             data.data.auction_details.is_register_active = 1
    //         }

    //         setLotData(data.data.auction_details)
    //         setLoading(false)
    //     }
    // }

    const toggleDrawer = (event, data) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (Object.keys(data) !== 0) {
            setData(data)
            setTDrawer(true)
        } else {
            setData({})
            setTDrawer(false)
        }
    }

    const getnerateImages = (array, auctionTitle) => {
        let product = array.map((data) => {
            let images = []
            let ava = ''
            if (data.lotImages.length !== 0) {
                ava = `${process.env.REACT_APP_PRODUCT_IMG}/${data.lotImages[0].file_name}`
                images = data.lotImages.map((img) => {
                    let image = `${process.env.REACT_APP_PRODUCT_IMG}/${img.file_name}`
                    return { original: image, thumbnail: image }
                })
            } else {
                images = [{ original: '', thumbnail: '' }]
            }

            return { ...data, productImages: images, productAva: ava }
        })
        return product
    }

    const getAuctions = async (body) => {
        let { data } = await axios.post('mobileapi/getauctionlotdetails', body)
        setLoading(false)
        if (data && data.success) {
            if (Object.keys(data.data.auction_details).length !== 0) {
                setLotData({ ...data.data.auction_details, ...data.data.min_max_date_closed })
                setLoading(false)
            }
        }
    }

    const getLotAuctions = async (body) => {
        body.need_bid_status = 'yes'
        let { data } = await axios.post('mobileapi/lotSearch', body)
        setLoading(false)

        if (data.success) {
            if (data?.result?.listOfProjects?.length !== 0) {
                let products = getnerateImages(data.result.listOfProjects, '')
                setAuctionData(products)
            }
        }
    }

    // useEffect(() => {
    //     async function fetchData() {
    //         const ipaddress = await publicIp.v4()
    //         const ipLoc = await ipLocation(ipaddress)
    //         console.log('ipLoc', ipLoc)
    //         setIPAddress(ipaddress)
    //     }
    //     fetchData()
    // }, [])

    const handlePopoverOpen = (event, text) => {
        setPopText(text)
        setAnchorEl(event.currentTarget)
    }

    const handlePopoverClose = () => {
        setAnchorEl(null)
    }

    const addFav = async (id, isFav) => {
        if (isAuthenticate()) {
            let data = await updateFav({ id: id, userid: props.userDetails.userdetails.id }, isFav)
            if (data) {
                let position = findIndex(auctionData, { id: id })
                if (position !== -1) {
                    let dataFav = auctionData[position]
                    dataFav = { ...dataFav, isFav: isFav === 0 ? 1 : 0 }
                    auctionData[position] = dataFav
                    if (Object.keys(data).length !== 0) {
                        setData(dataFav)
                    }
                    setAuctionData([...auctionData])
                }
            }
        } else {
            history.push({ pathname: '/login', state: props.location })
        }
    }

    const handleOnChange = (e) =>
        !isNaN(e.target.value)
            ? setAmount({ ...amount, [e.target.name]: e.target.value })
            : setAmount({ ...amount })

    const onKeyPress = (e, id) => {
        if (e.key === 'Enter') {
            let productPosition = findIndex(auctionData, { id: id })
            if (productPosition !== -1) {
                let productPosition = findIndex(auctionData, { id: id })
                let product = auctionData[productPosition]
                handleClick(
                    {
                        id: product.id,
                        wsprice: amount[product.id],
                        bid_increment: product.incrementamt,
                    },
                    parseFloat(product.next_bid),
                )
            }
        }
    }

    const handleClick = async (
        body,
        nPrice,
        auction_type,
        lot_id,
        incr_amt,
        crnt_amt,
        max_of_bd,
    ) => {
        if (isAuthenticate()) {
            if (lotData.con_check === 1) {
                if (parseInt(lotData.isRegistered) === 0) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Please Register Live Auction And Participate.',
                        timer: 2500,
                        showConfirmButton: false,
                        position: 'center',
                    })
                    //return window.scrollTo(0, 0)
                } else {
                    body.hard_bid = 0
                    body.auction_io = 1
                }
            }
            if (
                moment(props.serverTime).isBefore(moment(lotData.date_added)) &&
                auction_type !== 1
            ) {
                toast.warning('Auction is not started!')
                return false
            }

            if (nPrice > body.wsprice) {
                toast.warning(`Enter $${nPrice} or more`)
            } else {
                if (auction_type === 1) {
                    await preAuctionBid({
                        wsprice: parseInt(body.wsprice),
                        userid: props.userDetails.userdetails.id,
                        id: parseInt(lot_id),
                        lotid: parseInt(lot_id),
                        bidplan: 'auto',
                        auctionid: parseInt(id),
                    })
                    setAmount({ ...amount, [body.id]: '' })
                    // getAuctions(newBody)
                } else {
                    await commonBidding({
                        ...body,
                        email: props.userDetails.userdetails.email,
                        userid: props.userDetails.id,
                    })
                    setAmount({ ...amount, [body.id]: '' })
                    // getAuctions(newBody)
                }
            }
        } else {
            history.push({ pathname: '/login', state: props.location })
        }
    }

    // const bottomDrawer = () => { }

    // useEffect(() => {
    //     Swal.fire({
    //         icon: 'warning',
    //         title: 'This Auction Has Been Ended By Admin Now.Thanks For Participate The Auction.',
    //         //timer: 1500,
    //         showConfirmButton: true,
    //         position: 'center',
    //     }).then(function (data) {
    //         if (data.isConfirmed) {
    //             return history.push('/search')
    //         }
    //     })
    // }, [])

    const handleLotChange = (e) => {
        setPageLotCount(e.target.value)
        let query = new URLSearchParams(props.location.search)
        query.set('scrollLocation', 0)
        query.set('perPage', e.target.value)
        history.replace({
            pathname: props.location.pathname,
            search: '?' + query.toString(),
        })
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            let now = moment()
            let AuctionStartDateTime = moment(lotData.date_added)
            let numberOfHours = moment.duration(AuctionStartDateTime.diff(now)).asHours()
            if (numberOfHours === 1) {
                //If total number of hours left for auction to start is 1, then enable Register For Auction and clear interval
                setIsRegisterLiveAuctionEnabled(true)
                clearInterval(intervalId)
            }
        }, 1000)
        return () => clearInterval(intervalId)
    }, [lotData])

    const onImageLoad = (e) => {
        window.scrollTo({ top: scrollHeight, bottom: 0, behavior: 'smooth' })
    }

    const onLotChange = (e) => setLotText(e.target.value)

    const onLotSubmit = (e) => {
        e.preventDefault()
        let query = new URLSearchParams(location.search)
        query.set('lotSearch', lotText != undefined ? lotText : '')
        query.set('page', 1)
        query.set('scrollLocation', null)
        localStorage.setItem('scrollLocation', 0)
        history.push({
            pathname: props.location.pathname,
            search: '?' + query.toString(),
        })
    }

    // console.log('auctionDataauctionDataauctionDataauctionData', auctionData)

    useEffect(() => {
        console.log(localStorage.getItem('scrollLocation'), 'local storeage get item')
        let scrollValue = localStorage.getItem('scrollLocation')
        let queryVw = qs.parse(props.location.search, { ignoreQueryPrefix: true })
        let query = new URLSearchParams(props.location.search)
        if (scrollValue != null && scrollValue != 0) {
            if (scrollValue != queryVw.scrollLocation) {
                query.set('scrollLocation', scrollValue)
                history.replace({
                    pathname: props.location.pathname,
                    search: '?' + query.toString(),
                })
                localStorage.setItem('scrollLocation', 0)
            } else if (scrollValue == queryVw.scrollLocation) {
                query.set('scrollLocation', queryVw.scrollLocation)
                history.replace({
                    pathname: props.location.pathname,
                    search: '?' + query.toString(),
                })
                localStorage.setItem('scrollLocation', 0)
            } else {
                query.set('scrollLocation', 0)
                history.replace({
                    pathname: props.location.pathname,
                    search: '?' + query.toString(),
                })
            }
        }
    }, [])

    useEffect(() => {
        if (lotText != undefined && lotText != '') {
            dispatch(
                rapidSearch({
                    search_keyword: lotText,
                    status: 'open',
                    type: 'lots',
                    lotof: Number(id),
                }),
            )
        }
    }, [lotText])

    useEffect(() => {
        if (props.searchText?.rapidSearch?.length > 0) {
            setSearchText(props.searchText.rapidSearch)
        }
    }, [props.searchText])

    const modalClose = () => {
        setmodalOpen(!modalOpen)
    }

    const handleChange = () => {
        setAgreeterms(!agreeterms)
    }

    useEffect(() => {
        getAuctions({ auctionid: props.match.params.id })
    }, [props.match.params.id])

    const viewProductRef = useRef(auctionData)
    const userRef = useRef(user)

    // Sets product and user refrences on page load
    useEffect(() => {
        viewProductRef.current = auctionData
        userRef.current = user
    })

    const handler = (message, type) => {
        messageHandler(message, viewProductRef.current, userRef.current, setAuctionData, type)
    }

    useEffect(() => {
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })
        socket.on('realclosedupdates', (data) => {
            data.id = data.pid
            handler(data, 'realclosedupdates')
        })
        socket.on('cancelbidemitted', (data) => {
            console.log(
                'lllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllll',
                data,
            )
            handler(data, 'cancelbidemitted')
        })
        return () => {
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('realclosedupdates', (data) => {
                data.id = data.pid
                handler(data, 'realclosedupdates')
            })
            socket.off('cancelbidemitted', (data) => {
                handler(data, 'cancelbidemitted')
            })
        }
    }, [])

    return (
        <>
            {loading ? (
                <div className="mnHtcontnr">
                    <div className="liveLotsLoader">
                        <Loaders name="live_auction" isLoading={loading} />
                    </div>
                </div>
            ) : (
                <div className="productCntWrp customContainer">
                    <ToastContainer
                        autoClose={5000}
                        hideProgressBar={true}
                        pauseOnFocusLoss={false}
                    />
                    {Object.keys(lotData).length !== 0 && (
                        <div className="pdtVwRp px-lg-5">
                            <div className="productTimer d-flex align-items-start justify-content-between">
                                <div className="pdtNmInfo text-left">
                                    <p className="productTitle mb-0">{lotData.title}</p>
                                    <small>Auction Id: {lotData.id}</small>
                                </div>
                                <div className="d-flex align-items-start timerdiV">
                                    <div className={`lotTimer brdrRt text-left`}>
                                        {showTimer ? (
                                            <>
                                                {/* <span>Time Left:</span>{' '} */}

                                                <Timer
                                                    productTime={{
                                                        start: lotData.date_added,
                                                        end: lotData.date_closed,
                                                    }}
                                                    timerBasic={true}
                                                    timedauction={true}
                                                />
                                            </>
                                        ) : (
                                            <span>Auction Closed</span>
                                        )}
                                    </div>
                                    {lotData.con_check === 1 && lotData.market_status != 'sold' && (
                                        <div className="vwLvActn">
                                            {parseInt(lotData.isRegistered) === 1 ? (
                                                <>
                                                    {new Date() > new Date(lotData.date_closed) ? (
                                                        ''
                                                    ) : (
                                                        <PrimaryButton
                                                            label={
                                                                <span className="d-flex align-items-center">
                                                                    <span className="material-icons mr-2 lvActnIcon pulse">
                                                                        radio_button_checked
                                                                    </span>
                                                                    <span>Enter Live Auction</span>
                                                                </span>
                                                            }
                                                            onClick={() =>
                                                                history.push(
                                                                    `/livelots/${lotData.id}/${props.userDetails.userdetails.id}`,
                                                                )
                                                            }
                                                        />
                                                    )}
                                                </>
                                            ) : (
                                                <>
                                                    <PrimaryButton
                                                        label={
                                                            <span className="d-flex align-items-center">
                                                                <span>
                                                                    CLICK HERE TO REGISTER FOR
                                                                    BIDDING
                                                                </span>
                                                            </span>
                                                        }
                                                        //onClick={() => lotauctionreg()}
                                                        // disabled={!isRegisterLiveAuctionEnabled}
                                                    />{' '}
                                                    <div className="d-flex align-items-start">
                                                        <div className="checkTndC">
                                                            <CheckBox
                                                                name="agreeterms"
                                                                value={agreeterms}
                                                                onchange={handleChange}
                                                                checked={agreeterms}
                                                            />
                                                        </div>
                                                        <p
                                                            style={{
                                                                marginTop: '10px',
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            Please Accept{' '}
                                                            <a
                                                                style={{
                                                                    color: 'blue',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={(e) => modalClose()}
                                                            >
                                                                Terms & Conditions
                                                            </a>
                                                        </p>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {lotData.con_check === 1 && (
                                <>
                                    {parseInt(lotData.isRegistered) === 1 && (
                                        <>
                                            {parseInt(lotData.is_register_active) === 1 ? (
                                                <div className="lotInfoReg">
                                                    <span>
                                                        Registration Pending, We'll send you an
                                                        email once you've been approved to bid.
                                                    </span>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    )}
                                </>
                            )}

                            <div className="productDescp d-flex px-0">
                                <LazyLoadImage
                                    src={process.env.REACT_APP_PRODUCT_IMG + lotData.avatar}
                                    onError={(e) => {
                                        onImageErrorScroll(e, scrollHeight)
                                    }}
                                    effect="blur"
                                    placeholderSrc="/images/imageLoading.svg"
                                    height="100%"
                                    className="auctionImage"
                                    afterLoad={onImageLoad}
                                />
                                <div className="pdtContent w-100">
                                    <div className="timeProduct d-flex justify-content-between align-items-center">
                                        <div className="catPdtTitle w-100 pr-5">
                                            {/* <p className="productTitle">{lotData.title}</p>
                                    <p className="productCat">{lotData.category}</p> */}
                                            <div className="dateTimeWrp pt-0 row">
                                                <div className="itemsWrp col-md-6">
                                                    <p className="itemTitle">
                                                        Total Items :
                                                        <span className="items ml-2">
                                                            {lotData.lot_count}
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="startDateCnt col-md-6">
                                                    <p className="dateTitle">Auction Start Date:</p>
                                                    <p className="dateTime">
                                                        {moment(lotData.date_added)
                                                            .tz('America/Denver')
                                                            .format('MM/DD/YYYY hh:mm A z')}{' '}
                                                    </p>
                                                </div>
                                                <div className="startDateCnt col-md-6">
                                                    <p className="dateTitle">
                                                        Auction Begins To End:
                                                    </p>
                                                    <p className="dateTime">
                                                        {moment(lotData.min_date_closed)
                                                            .tz('America/Denver')
                                                            .format('MM/DD/YYYY hh:mm A z')}{' '}
                                                    </p>
                                                </div>
                                                <div className="startDateCnt col-md-6">
                                                    <p className="dateTitle">
                                                        Last Item Approx Ends On:
                                                    </p>
                                                    <p className="dateTime">
                                                        {moment(lotData.max_date_closed)
                                                            .tz('America/Denver')
                                                            .format('MM/DD/YYYY hh:mm A z')}{' '}
                                                    </p>
                                                </div>
                                                {/* <div className="EndDateCnt">
                                            <p className="dateTitle">Auction End Date :</p>
                                            <p className="enddateTime">
                                                {moment(lotData.date_closed).format(
                                                    'MM/DD/YYYY HH:mm A',
                                                )}
                                            </p>
                                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <p className="descrTitle">Description :</p>
                                    <p className="description d-flex align-items-start flex-wrap">
                                        {(lotData.description &&
                                            lotData.description?.length < 30) ||
                                        showDescription ? (
                                            <>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: lotData.description,
                                                    }}
                                                ></span>
                                                {lotData.description?.length > 30 && (
                                                    <div
                                                        className="w-100 cursorDecoy shwMrBtn pt-1"
                                                        onClick={() => setShowDescription(false)}
                                                    >
                                                        <b>
                                                            <u>Show Less</u>
                                                        </b>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                {lotData.description && (
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: lotData.description.slice(
                                                                0,
                                                                30,
                                                            ),
                                                        }}
                                                    ></span>
                                                )}
                                                ...
                                                <div
                                                    className="w-100 cursorDecoy shwMrBtn pt-1"
                                                    onClick={() => setShowDescription(true)}
                                                >
                                                    <b>
                                                        <u>Show More</u>
                                                    </b>
                                                </div>
                                            </>
                                        )}
                                    </p>
                                    {/* <div className="publicChat">
                                <p className="chatTitle"></p>
                                <Chat pid={props.match.params.id} />
                            </div> */}
                                </div>
                            </div>
                        </div>
                    )}
                    {/* {console.log('auctiondatavalue-------->', auctionData)} */}
                    <div
                        className={`pdtVwCntWrp customContainer d-flex align-items-center justify-content-between mb-4 ${
                            sticky.isSticky ? 'sticky' : 'not-sticky'
                        }`}
                        ref={headerRef}
                    >
                        <form className="" onSubmit={onLotSubmit}>
                            <div className="lotNoSearchWrapper">
                                <Autocomplete
                                    freeSolo
                                    options={searchText}
                                    // value={lotText}
                                    inputValue={lotText}
                                    getOptionLabel={(option) =>
                                        option.sku
                                            ? `${option.title} (${option.sku})`
                                            : option.title
                                    }
                                    onChange={(event, newValue) => {
                                        console.log('newValue', newValue?.title, newValue)
                                        setLotText(
                                            newValue?.title != undefined && newValue?.title != null
                                                ? newValue.title
                                                : newValue != null
                                                ? newValue
                                                : '',
                                        )
                                    }}
                                    onInputChange={(event, newInputValue, reason) => {
                                        if (reason === 'clear') {
                                            setLotText('')
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant={'outlined'}
                                            placeholder="Search"
                                            value={lotText}
                                            onChange={onLotChange}
                                        />
                                    )}
                                />
                                <IconButton type="submit">
                                    <span className="material-icons">search</span>
                                </IconButton>
                            </div>
                        </form>
                        <div className="d-flex align-items-center justify-content-end results-per-page">
                            <div className="d-flex align-items-center rpp-left-wrap">
                                <label className="mb-0 mr-2">Results per page: </label>
                                <select
                                    name="pageLtCnt"
                                    onChange={handleLotChange}
                                    value={pageLotCount}
                                >
                                    <option value={20}>20</option>
                                    <option value={40}>40</option>
                                    <option value={100}>100</option>
                                    {/* <option value={2000}>All</option> */}
                                </select>
                            </div>
                            <div className="gridListToggle ml-3 mb-0 mt-0">
                                <Button
                                    className={auctionView === 'Grid' ? 'active' : ''}
                                    onClick={() => setAuctionView('Grid')}
                                >
                                    <span className="material-icons">apps</span>
                                    <span className="d-none-xs">GRID</span>
                                </Button>
                                <Button
                                    className={auctionView === 'List' ? 'active' : ''}
                                    onClick={() => setAuctionView('List')}
                                >
                                    <span className="material-icons">view_list</span>
                                    <span className="d-none-xs">LIST</span>
                                </Button>
                            </div>
                        </div>
                    </div>

                    {auctionData.length !== 0 && auctionView === 'Grid' ? (
                        <div className="lotGrid customContainer">
                            {auctionData.map((data, index) => (
                                <Gridview
                                    imgSrc={
                                        data.avatar_vc
                                            ? `${
                                                  process.env.REACT_APP_PRODUCT_IMG +
                                                  data?.lotImages[0]?.file_name
                                              }`
                                            : '/images/Logo.png'
                                    }
                                    Name={data.title}
                                    currentPrice={data.wprice}
                                    offerPrice={data.current_max_offer_bid}
                                    label={'View Auction'}
                                    timerBasic={true}
                                    l_data={data}
                                    con_check={0}
                                    user={user}
                                    // onClick={() => {
                                    //     window.open(
                                    //         `/lotview/${id}/${data.id}/${
                                    //             props.userDetails.userdetails.id || 0
                                    //         }?page=${parseInt(body.page)}&scrollLocation=${
                                    //             window.pageYOffset
                                    //         }&perPage=${pageLotCount}`,
                                    //         '_blank',
                                    //     )
                                    // }}
                                    onClick={() => (
                                        localStorage.setItem('scrollLocation', window.pageYOffset),
                                        handleRedirectInternal(
                                            history,
                                            `${
                                                lotData.con_check ? 'lotview' : 'timedlotView'
                                            }/${id}/${data.id}/${
                                                props.userDetails.userdetails.id || 0
                                            }`,
                                            `?page=${parseInt(body.page)}&scrollLocation=${
                                                window.pageYOffset
                                            }&perPage=${pageLotCount}`,
                                        )
                                    )}
                                    // redirectUrl={`${
                                    //     lotData.con_check ? '/lotview' : '/timedlotView'
                                    // }/${id}/${data.id}/${
                                    //     props.userDetails.userdetails.id || 0
                                    // }?page=${parseInt(body.page)}&scrollLocation=${
                                    //     window.pageYOffset
                                    // }&perPage=${pageLotCount}`}
                                    // onClick={(e) => toggleDrawer(e, data)}
                                    id={data.lotof}
                                    prodId={data.id}
                                    isFav={data.isFav}
                                    onFavClick={() => addFav(data.id, data.isFav)}
                                    lotId={data.sku}
                                    startTime={data.date_added}
                                    endTime={data.date_closed}
                                    lowest={data.lowest}
                                    highest={data.highest}
                                    market_status={data.market_status}
                                    card_type="lotView"
                                    lotBidding={
                                        new Date() < new Date(lotData.date_added) ? (
                                            <div className="placeBid gridViewbtn">
                                                <CustomInput
                                                    placeholder={`Enter bid`}
                                                    label={`Enter bid`}
                                                    variant="outlined"
                                                    onChange={handleOnChange}
                                                    pattern="^\d*(.\d{0,2})?$"
                                                    name={String(data.id)}
                                                    value={amount[data.id] || ''}
                                                    onKeyPress={(e) => onKeyPress(e, data.id)}
                                                />
                                                <PrimaryButton
                                                    label={
                                                        lotData.con_check === 1
                                                            ? 'Place Max Bid'
                                                            : 'Place Max Bid'
                                                    }
                                                    disabled={
                                                        isAuthenticate() === undefined ||
                                                        amount[data.id] === undefined ||
                                                        amount[data.id] === ''
                                                    }
                                                    onClick={(e) =>
                                                        handleClick(
                                                            {
                                                                id: data.id,
                                                                wsprice: amount[data.id],
                                                                bid_increment: data.incrementamt,
                                                            },
                                                            parseFloat(data.next_bid),
                                                            lotData.con_check,
                                                            data.id,
                                                            data.incrementamt,
                                                            data.wprice,
                                                            data.current_max_offer_bid,
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : lotData.current_projectid !== data.id &&
                                          data.market_status === 'open' &&
                                          new Date() < new Date(data.date_closed) ? (
                                            <div className="placeBid gridViewbtn">
                                                <CustomInput
                                                    placeholder={`Enter bid`}
                                                    label={`Enter bid`}
                                                    variant="outlined"
                                                    onChange={handleOnChange}
                                                    pattern="^\d*(.\d{0,2})?$"
                                                    name={String(data.id)}
                                                    value={amount[data.id] || ''}
                                                    onKeyPress={(e) => onKeyPress(e, data.id)}
                                                />
                                                <PrimaryButton
                                                    label={
                                                        lotData.con_check === 1
                                                            ? 'Place Max Bid'
                                                            : 'Place Max Bid'
                                                    }
                                                    disabled={
                                                        isAuthenticate() === undefined ||
                                                        amount[data.id] === undefined ||
                                                        amount[data.id] === ''
                                                    }
                                                    onClick={(e) =>
                                                        handleClick(
                                                            {
                                                                id: data.id,
                                                                wsprice: amount[data.id],
                                                                bid_increment: data.incrementamt,
                                                            },
                                                            parseFloat(data.next_bid),
                                                            lotData.con_check,
                                                            data.id,
                                                            data.incrementamt,
                                                            data.wprice,
                                                            data.current_max_offer_bid,
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            ' '
                                        )
                                    }
                                    highbid_user_id={data.highbid_user_id}
                                    userDetails={props.userDetails}
                                />
                            ))}
                        </div>
                    ) : mobile ? (
                        <div className="lotPdtWrp customContainer">
                            {auctionData.map((data, index) => (
                                <MobileListCard
                                    imgSrc={
                                        data.avatar
                                            ? `${
                                                  process.env.REACT_APP_PRODUCT_IMG +
                                                  data?.lotImages[0]?.file_name
                                              }`
                                            : '/images/Logo.png'
                                    }
                                    Name={data.title}
                                    currentPrice={data.wprice}
                                    offerPrice={data.current_max_offer_bid}
                                    label={'View Auction'}
                                    timerBasic={true}
                                    // onClick={() => {
                                    //     window.open(
                                    //         `/lotview/${id}/${data.id}/${
                                    //             props.userDetails.userdetails.id || 0
                                    //         }?page=${parseInt(body.page)}&scrollLocation=${
                                    //             window.pageYOffset
                                    //         }&perPage=${pageLotCount}`,
                                    //         '_blank',
                                    //     )
                                    // }}
                                    onClick={() => (
                                        localStorage.setItem('scrollLocation', window.pageYOffset),
                                        handleRedirectInternal(
                                            history,
                                            `${
                                                lotData.con_check ? 'lotview' : 'timedlotView'
                                            }/${id}/${data.id}/${
                                                props.userDetails.userdetails.id || 0
                                            }`,
                                            `?page=${parseInt(body.page)}&scrollLocation=${
                                                window.pageYOffset
                                            }&perPage=${pageLotCount}`,
                                        )
                                    )}
                                    redirectUrl={`${
                                        lotData.con_check ? '/lotview' : '/timedlotView'
                                    }/${id}/${data.id}/${
                                        props.userDetails.userdetails.id || 0
                                    }?page=${parseInt(body.page)}&scrollLocation=${
                                        window.pageYOffset
                                    }&perPage=${pageLotCount}`}
                                    // onClick={(e) => toggleDrawer(e, data)}
                                    bidCount={data.bid_count}
                                    id={data.lotof}
                                    prodId={data.id}
                                    isFav={data.isFav}
                                    onFavClick={() => addFav(data.id, data.isFav)}
                                    lotId={data.sku}
                                    startTime={data.date_added}
                                    endTime={data.date_closed}
                                    lowest={data.lowest}
                                    highest={data.highest}
                                    market_status={data.market_status}
                                    card_type="lotView"
                                    description={data.description}
                                    handleBidHistory={(e) => handleHistory(data.id)}
                                    lotBidding={
                                        new Date() < new Date(lotData.date_added) ? (
                                            <div className="placeBid gridViewbtn">
                                                <CustomInput
                                                    placeholder={`Enter bid`}
                                                    label={`Enter bid`}
                                                    variant="outlined"
                                                    onChange={handleOnChange}
                                                    pattern="^\d*(.\d{0,2})?$"
                                                    name={String(data.id)}
                                                    value={amount[data.id] || ''}
                                                    onKeyPress={(e) => onKeyPress(e, data.id)}
                                                />
                                                <PrimaryButton
                                                    label={
                                                        lotData.con_check === 1
                                                            ? 'Place Max Bid'
                                                            : 'Place Max Bid'
                                                    }
                                                    disabled={
                                                        isAuthenticate() === undefined ||
                                                        amount[data.id] === undefined ||
                                                        amount[data.id] === ''
                                                    }
                                                    onClick={(e) =>
                                                        handleClick(
                                                            {
                                                                id: data.id,
                                                                wsprice: amount[data.id],
                                                                bid_increment: data.incrementamt,
                                                            },
                                                            parseFloat(data.next_bid),
                                                            lotData.con_check,
                                                            data.id,
                                                            data.incrementamt,
                                                            data.wprice,
                                                            data.current_max_offer_bid,
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : lotData.current_projectid !== data.id &&
                                          data.market_status === 'open' &&
                                          new Date() < new Date(data.date_closed) ? (
                                            <div className="placeBid gridViewbtn">
                                                <CustomInput
                                                    placeholder={`Enter bid`}
                                                    label={`Enter bid`}
                                                    variant="outlined"
                                                    onChange={handleOnChange}
                                                    pattern="^\d*(.\d{0,2})?$"
                                                    name={String(data.id)}
                                                    value={amount[data.id] || ''}
                                                    onKeyPress={(e) => onKeyPress(e, data.id)}
                                                />
                                                <PrimaryButton
                                                    label={
                                                        lotData.con_check === 1
                                                            ? 'Place Max Bid'
                                                            : 'Place Max Bid'
                                                    }
                                                    disabled={
                                                        isAuthenticate() === undefined ||
                                                        amount[data.id] === undefined ||
                                                        amount[data.id] === ''
                                                    }
                                                    onClick={(e) =>
                                                        handleClick(
                                                            {
                                                                id: data.id,
                                                                wsprice: amount[data.id],
                                                                bid_increment: data.incrementamt,
                                                            },
                                                            parseFloat(data.next_bid),
                                                            lotData.con_check,
                                                            data.id,
                                                            data.incrementamt,
                                                            data.wprice,
                                                            data.current_max_offer_bid,
                                                        )
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            ' '
                                        )
                                    }
                                />
                            ))}
                        </div>
                    ) : (
                        <div className="lotPdtWrp customContainer">
                            <table className="table tableCnt">
                                <thead className="tableHeader">
                                    <tr>
                                        <th>Lot #</th>
                                        <th>Image</th>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>Est</th>
                                        {/* <th>
                                            Closing <br /> At
                                        </th> */}
                                        <th>
                                            {lotData.market_status === 'sold' ||
                                            lotData.market_status === 'unsold'
                                                ? 'Sold Price'
                                                : 'Current bid'}
                                        </th>
                                        {/* {new Date() < new Date(lotData.date_added) && (
                                    <th style={{ whiteSpace: 'pre' }}>Offer Price</th>
                                )} */}

                                        <th>
                                            No .Of <br /> Bids
                                        </th>
                                        {/* <th>Status</th> */}
                                        {/* <th>Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {auctionData.map((data, index) => (
                                        <tr key={data.id}>
                                            <td className="slNo">
                                                <span
                                                    className="cursor"
                                                    // onClick={() => {
                                                    //     window.open(
                                                    //         `/lotview/${id}/${data.id}/${
                                                    //             props.userDetails.userdetails.id ||
                                                    //             0
                                                    //         }?page=${parseInt(
                                                    //             body.page,
                                                    //         )}&scrollLocation=${
                                                    //             window.pageYOffset
                                                    //         }&perPage=${pageLotCount}`,
                                                    //         '_blank',
                                                    //     )
                                                    // }}
                                                    onClick={() => (
                                                        localStorage.setItem(
                                                            'scrollLocation',
                                                            window.pageYOffset,
                                                        ),
                                                        handleRedirectInternal(
                                                            history,
                                                            `${
                                                                lotData.con_check
                                                                    ? 'lotview'
                                                                    : 'timedlotView'
                                                            }/${id}/${data.id}/${
                                                                props.userDetails.userdetails.id
                                                            }`,
                                                            `?page=${parseInt(
                                                                body.page,
                                                            )}&scrollLocation=${
                                                                window.pageYOffset
                                                            }&perPage=${pageLotCount}`,
                                                        )
                                                    )}
                                                    // onClick={(e) => toggleDrawer(e, data)}
                                                >
                                                    {data.sku}
                                                </span>
                                            </td>
                                            <td className="lotImg lotCardWrpr">
                                                <div className="favBox">
                                                    <span
                                                        name={data.id}
                                                        onClick={() => addFav(data.id, data.isFav)}
                                                        className="material-icons Favicon"
                                                    >
                                                        {data.isFav === 1
                                                            ? 'favorite'
                                                            : 'favorite_border'}
                                                    </span>
                                                </div>
                                                <div
                                                    className="imgBtn"
                                                    // onClick={() => {
                                                    //     window.open(
                                                    //         `/lotview/${id}/${data.id}/${
                                                    //             props.userDetails.userdetails.id ||
                                                    //             0
                                                    //         }?page=${parseInt(
                                                    //             body.page,
                                                    //         )}&scrollLocation=${
                                                    //             window.pageYOffset
                                                    //         }&perPage=${pageLotCount}`,
                                                    //         '_blank',
                                                    //     )
                                                    // }}
                                                    // onClick={() => (
                                                    //     localStorage.setItem(
                                                    //         'scrollLocation',
                                                    //         window.pageYOffset,
                                                    //     ),
                                                    //     handleRedirectInternal(
                                                    //         history,
                                                    //         `${
                                                    //             lotData.con_check
                                                    //                 ? 'lotview'
                                                    //                 : 'timedlotView'
                                                    //         }/${id}/${data.id}/${
                                                    //             props.userDetails.userdetails.id
                                                    //         }`,
                                                    //         `?page=${parseInt(
                                                    //             body.page,
                                                    //         )}&scrollLocation=${
                                                    //             window.pageYOffset
                                                    //         }&perPage=${pageLotCount}`,
                                                    //     )
                                                    // )}
                                                    // onClick={(e) => toggleDrawer(e, data)}
                                                >
                                                    <Link
                                                        to={`${
                                                            lotData.con_check
                                                                ? '/lotview'
                                                                : '/timedlotView'
                                                        }/${id}/${data.id}/${
                                                            props.userDetails.userdetails.id || 0
                                                        }?page=${parseInt(
                                                            body.page,
                                                        )}&scrollLocation=${
                                                            window.pageYOffset
                                                        }&perPage=${pageLotCount}`}
                                                    >
                                                        <LazyLoadImage
                                                            alt={data.title}
                                                            src={
                                                                process.env.REACT_APP_PRODUCT_IMG +
                                                                data?.lotImages[0]?.file_name
                                                            }
                                                            onError={onImageError}
                                                            effect="blur"
                                                            placeholderSrc="/images/imageLoading.svg"
                                                            height="100%"
                                                            width="100%"
                                                        />
                                                    </Link>
                                                </div>
                                            </td>
                                            <td className="cat">
                                                <a
                                                    className="cursor"
                                                    // href={`${
                                                    //     lotData.con_check
                                                    //         ? 'lotview'
                                                    //         : 'timedlotView'
                                                    // }/${id}/${data.id}/${
                                                    //     props.userDetails.userdetails.id || 0
                                                    // }?page=${parseInt(body.page)}&scrollLocation=${
                                                    //     window.pageYOffset
                                                    // }&perPage=${pageLotCount}`}
                                                    // // onClick={() => {
                                                    //     window.open(
                                                    //         `/lotview/${id}/${data.id}/${
                                                    //             props.userDetails.userdetails.id ||
                                                    //             0
                                                    //         }?page=${parseInt(
                                                    //             body.page,
                                                    //         )}&scrollLocation=${
                                                    //             window.pageYOffset
                                                    //         }&perPage=${pageLotCount}`,
                                                    //         '_blank',
                                                    //     )
                                                    // }}
                                                    onClick={() => (
                                                        localStorage.setItem(
                                                            'scrollLocation',
                                                            window.pageYOffset,
                                                        ),
                                                        handleRedirectInternal(
                                                            history,
                                                            `${
                                                                lotData.con_check
                                                                    ? 'lotview'
                                                                    : 'timedlotView'
                                                            }/${id}/${data.id}/${
                                                                props.userDetails.userdetails.id
                                                            }`,
                                                            `?page=${parseInt(
                                                                body.page,
                                                            )}&scrollLocation=${
                                                                window.pageYOffset
                                                            }&perPage=${pageLotCount}`,
                                                        )
                                                    )}
                                                    dangerouslySetInnerHTML={{
                                                        __html: data.title,
                                                    }}
                                                    // onClick={(e) => toggleDrawer(e, data)}
                                                ></a>
                                            </td>
                                            <td className="decs">
                                                <div className="onclisk">
                                                    <Typography
                                                        aria-owns={
                                                            open ? 'mouse-over-popover' : undefined
                                                        }
                                                        aria-haspopup="true"
                                                        onMouseEnter={(e) =>
                                                            handlePopoverOpen(e, data.description)
                                                        }
                                                        onMouseLeave={handlePopoverClose}
                                                    >
                                                        {' '}
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: data.description,
                                                            }}
                                                        ></p>
                                                    </Typography>
                                                    <b
                                                        onMouseEnter={(e) =>
                                                            handlePopoverOpen(e, data.description)
                                                        }
                                                        onMouseLeave={handlePopoverClose}
                                                    >
                                                        read more
                                                    </b>
                                                </div>
                                            </td>
                                            <td style={{ whiteSpace: 'pre' }}>
                                                {currencyFormat(data.lowest)} -{' '}
                                                {currencyFormat(data.highest)}
                                            </td>
                                            {/* <td className="lotTime">
                                                <Timer
                                                    productTime={{
                                                        start: moment()
                                                            .subtract(1, 'hour')
                                                            .format(),
                                                        end: data.date_closed,
                                                    }}
                                                />
                                            </td> */}
                                            <td className="CurrentPrice">
                                                $ {setDecimalPoint(data.wprice, 2)}
                                            </td>
                                            {/* {new Date() < new Date(lotData.date_added) && (
                                        <td className="CurrentPrice">
                                            $ {setDecimalPoint(data.current_max_offer_bid, 2)}
                                        </td>
                                    )} */}
                                            <td className="bids">
                                                {data.nobids}
                                                {/* <a onClick={(e) => handleHistory(data.id)}>
                                                    {data.bid_count}
                                                </a> */}
                                            </td>
                                            {/* <td className="winningLabel">
                                                {data.highbid_user_id &&
                                                    props.userDetails &&
                                                    data.highbid_user_id ==
                                                        props.userDetails.userdetails.id && (
                                                        <b>You're Winning!</b>
                                                    )}
                                            </td> */}
                                            {/* <td>
                                                {new Date() < new Date(lotData.date_added) ? (
                                                    <div className="placeBid d-flex justify-content-end align-items-end">
                                                        <CustomInput
                                                            placeholder={`Enter $${setDecimalPoint(
                                                                parseFloat(data.next_bid),
                                                                2,
                                                            )} or more`}
                                                            variant="standard"
                                                            onChange={handleOnChange}
                                                            pattern="^\d*(.\d{0,2})?$"
                                                            name={String(data.id)}
                                                            value={amount[data.id] || ''}
                                                            onKeyPress={(e) =>
                                                                onKeyPress(e, data.id)
                                                            }
                                                        />
                                                        <PrimaryButton
                                                            label={
                                                                lotData.con_check === 1
                                                                    ? 'Place Max Bid'
                                                                    : 'Place Max Bid'
                                                            }
                                                            disabled={
                                                                isAuthenticate() === undefined ||
                                                                amount[data.id] === undefined ||
                                                                amount[data.id] === ''
                                                            }
                                                            onClick={(e) =>
                                                                handleClick(
                                                                    {
                                                                        id: data.id,
                                                                        wsprice: amount[data.id],
                                                                        bid_increment:
                                                                            data.incrementamt,
                                                                    },
                                                                    parseFloat(data.next_bid),
                                                                    lotData.con_check,
                                                                    data.id,
                                                                    data.incrementamt,
                                                                    data.wprice,
                                                                    data.current_max_offer_bid,
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ) : lotData.current_projectid !== data.id &&
                                                  data.market_status === 'open' &&
                                                  new Date() < new Date(data.date_closed) ? (
                                                    <div className="placeBid d-flex justify-content-end align-items-end">
                                                        <CustomInput
                                                            placeholder={`Enter $${setDecimalPoint(
                                                                parseFloat(data.next_bid),
                                                                2,
                                                            )} or more`}
                                                            variant="standard"
                                                            onChange={handleOnChange}
                                                            pattern="^\d*(.\d{0,2})?$"
                                                            name={String(data.id)}
                                                            value={amount[data.id] || ''}
                                                            onKeyPress={(e) =>
                                                                onKeyPress(e, data.id)
                                                            }
                                                        />
                                                        <PrimaryButton
                                                            label={
                                                                lotData.con_check === 1
                                                                    ? 'Place Max Bid'
                                                                    : 'Place Max Bid'
                                                            }
                                                            disabled={
                                                                isAuthenticate() === undefined ||
                                                                amount[data.id] === undefined ||
                                                                amount[data.id] === ''
                                                            }
                                                            onClick={(e) =>
                                                                handleClick(
                                                                    {
                                                                        id: data.id,
                                                                        wsprice: amount[data.id],
                                                                        bid_increment:
                                                                            data.incrementamt,
                                                                    },
                                                                    parseFloat(data.next_bid),
                                                                    lotData.con_check,
                                                                    data.id,
                                                                    data.incrementamt,
                                                                    data.wprice,
                                                                    data.current_max_offer_bid,
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                ) : (
                                                    ' '
                                                    // <div className="enterLvTst">
                                                    //     Enter Live Auction to Bid
                                                    // </div>
                                                )}
                                            </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <div className="pageNo">
                        {Object.keys(lotData).length !== 0 && Object.keys(body).length !== 0 && (
                            <Pagination
                                count={getPaginationCount(lotData.lot_count, pageLotCount)}
                                defaultPage={6}
                                boundaryCount={3}
                                onChange={(e, value) => {
                                    let query = new URLSearchParams(props.location.search)
                                    query.set('page', value)
                                    query.set('scrollLocation', 0)
                                    history.push({
                                        pathname: props.location.pathname,
                                        search: '?' + query.toString(),
                                    })
                                }}
                                page={parseInt(body.page)}
                            />
                        )}
                    </div>
                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover}
                        classes={{
                            paper: classes.paper,
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        onClose={handlePopoverClose}
                        disableRestoreFocus
                    >
                        <Typography>{popText}</Typography>
                    </Popover>
                    <ProductViewSlider
                        onCloseClick={(e) => setTDrawer(false)}
                        data={data}
                        // isOpen={Object.keys(data) != 0}
                        lotData={lotData}
                        isOpen={tDrawer}
                        addFav={addFav}
                        amount={amount}
                        handleOnChange={handleOnChange}
                        onKeyPress={onKeyPress}
                        handleClick={handleClick}
                        handleHistory={handleHistory}
                        currentProject={lotData.current_projectid !== data.id ? true : false}
                    />
                    <BidHistory
                        open={historyId !== undefined}
                        productId={historyId}
                        onClose={handleHistory}
                        auctionType={lotData.con_check === 1 ? 'liveAuction' : 'TimedAuction'}
                    />
                </div>
            )}
            <Popup
                modaltitle="Terms and Conditions"
                open={modalOpen}
                handleClose={() => modalClose()}
            >
                {' '}
                <div className="p-4 descFldDynTxt">
                    <h1>Terms & Conditions</h1>
                    <div
                        className="container text-left mt-4"
                        dangerouslySetInnerHTML={{
                            __html: terms_condition?.storeDetails?.results?.terms_condition,
                        }}
                    ></div>
                </div>
            </Popup>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.User ? state.User : {},
        bidding: state.bidding ? state.bidding : {},
        serverTime: state.serverTime ? state.serverTime.time : '',
        searchText: state.rapidSearch,
    }
}

export default connect(mapStateToProps, null)(ProductView)
